import { render, staticRenderFns } from "./CoproffStats.vue?vue&type=template&id=6643608e&scoped=true"
import script from "./CoproffStats.vue?vue&type=script&lang=js"
export * from "./CoproffStats.vue?vue&type=script&lang=js"
import style0 from "./CoproffStats.vue?vue&type=style&index=0&id=6643608e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643608e",
  null
  
)

export default component.exports